import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SiteLayout from './components/layout/SiteLayout';
import HomePage from './routes/HomePage';
import CategoryPage from './routes/CategoryPage';
import ProductDetailPage from './routes/ProductDetailPage';
import CartPage from './routes/CartPage';
import CheckoutPage from './routes/CheckoutPage';
import OrderSuccessPage from './routes/OrderSuccessPage';
import OrderTrackPage from './routes/OrderTrackPage';
import BlogPage from './routes/BlogPage';
import BlogPostPage from './routes/BlogPostPage';
import WishlistPage from './routes/WishlistPage';
import AccountPage from './routes/AccountPage';
import LookbookPage from './routes/LookbookPage';
import DropsPage from './routes/DropsPage';
import SizeGuidePage from './routes/SizeGuidePage';
import ReturnPolicyPage from './routes/ReturnPolicyPage';
import SearchPage from './routes/SearchPage';
import NotFoundPage from './routes/NotFoundPage';
import VerifyEmailRoute from './routes/VerifyEmailRoute';
import ResetPasswordPage from './routes/ResetPasswordPage';
import AdminRoute from './routes/AdminRoute';

const App = () => (
  <Routes>
    {/* Standalone routes (no main site chrome) */}
    <Route path="/admin/*" element={<AdminRoute />} />
    <Route path="/verify-email" element={<VerifyEmailRoute />} />
    <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

    {/* Main storefront with header, footer, cart drawer */}
    <Route element={<SiteLayout />}>
      <Route path="/" element={<HomePage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order/success/:orderNumber" element={<OrderSuccessPage />} />
      <Route path="/order/track" element={<OrderTrackPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/account/wishlist" element={<WishlistPage />} />
      <Route path="/wishlist" element={<Navigate to="/account/wishlist" replace />} />
      <Route path="/lookbook" element={<LookbookPage />} />
      <Route path="/drops" element={<DropsPage />} />
      <Route path="/size-guide" element={<SizeGuidePage />} />
      <Route path="/returns" element={<ReturnPolicyPage />} />
      <Route path="/search" element={<SearchPage />} />

      {/* CategoryPage validates the realm slug internally and redirects to home for unknown realms. */}
      <Route path="/:realm" element={<CategoryPage />} />
      <Route path="/:realm/:slug" element={<ProductDetailPage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Route>
  </Routes>
);

export default App;
